import { useSignOut, useUserData } from "@nhost/react";
import React from "react";
import { Link } from "react-router-dom";
import Posts from "../blogPost/Posts";
import Search from "./Search";

const Home = () => {
  const { signOut } = useSignOut();
  const user = useUserData();

  return (
    <div>
      <div className="bg-blue-200  w-full h-96  flex justify-around align-middle   ">
        <Search/>
        <div className="text-3xl my-10 ">
          <Link to="/createPost">Create A Post --></Link>
        </div>
      </div>
      <Posts />
    </div>
  );
};

export default Home;
